module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dropdown', {
    staticClass: "v-select",
    style: ({
      width: _vm.width
    }),
    attrs: {
      "is-select": "",
      "size": _vm.size,
      "width": _vm.width,
      "maxWidth": _vm.maxWidth,
      "isMultiple": _vm.isMultiple,
      "textAlign": _vm.textAlign,
      "min": _vm.min,
      "max": _vm.max,
      "isInput": _vm.isInput
    },
    on: {
      "change": _vm.dropdownChange
    },
    model: {
      value: (_vm.internalOptions),
      callback: function($$v) {
        _vm.internalOptions = $$v
      },
      expression: "internalOptions"
    }
  }, [_c('span', [(_vm.isInput) ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputValue),
      expression: "inputValue"
    }],
    staticClass: "v-select-input",
    attrs: {
      "placeholder": _vm.placeholder,
      "type": "text"
    },
    domProps: {
      "value": (_vm.inputValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputValue = $event.target.value
      }
    }
  })] : [_c('span', {
    staticClass: "v-select-selected-span"
  }, [_vm._v(_vm._s(_vm.showSelectInfo()))])], _vm._v(" "), _c('i', {
    staticClass: "v-select-selected-i v-icon-down-dir"
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ab36078"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-easytable/libs/v-select/src/select.vue
// module id = 1653
// module chunks = 2